import { ChangeDetectorRef, Component, ElementRef, HostListener, isDevMode, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AppStatic, ContentService } from '../_core';
import { LcpHelper } from '../_core/_helpers/lcp-helper';
import { ActivatedRoute, Router } from '@angular/router';

import { fromEvent, combineLatest, Subject } from "rxjs";
import { map, takeUntil } from "rxjs/operators";


// animations inspired by: 
// https://www.youtube.com/watch?v=HSxQbGXDo3U&ab_channel=BrianTreese
// https://stackblitz.com/edit/stackblitz-starters-3ufzct?file=src%2Fsign-up-form%2Fsign-up-form.component.ts

@Component({
  selector: 'lcp-collection-logos',
  templateUrl: './collection-logos.component.html',
  styleUrls: ['./collection-logos.component.scss'],
})
export class CollectionLogosComponent implements OnInit, OnDestroy {

  @ViewChild('logosSizing') logosSizing: ElementRef
  @ViewChild('logosContainerOuter') logosContainerOuter: ElementRef

  slug = 'collection--logos'
  content: any
  logos: any
  fields: any

  filters: any[] = [] // isActive, display, tag
  filterGroups: any = []
  activeFilterGroup: any
  activeFilterGroupNames: any[] = []

  activeFilters: any[] = []

  queryParam$: any
  queryParams: any = {}

  placeholder: string = 'no results'

  showLogos: boolean = false
  // tagNameLookup = LcpHelper.tagNameLookup

  windowResize$: any
  destroy$: Subject<boolean> = new Subject<boolean>();

  logoRow: any[] = []
  logoColumn: any[] = []
  maxLogos = 300

  hoverRow: number
  hoverColumn: number

  anyFilterGroup: any
  clientFilterGroup: any
  clientFilters: any[]

  tags: any

  logoCardInfoDefaultColor: '#F2F2F2';

  isFourColumns: boolean
  isThreeColumns: boolean
  isTwoColumns: boolean

  totalColumns: number = 5
  breakpointTwoColumns = 710
  breakpointThreeColumns = 900
  breakpointFourColumns = 1300
  


  constructor(
    private cdr: ChangeDetectorRef,
    public contentService: ContentService,
    public lcpHelper: LcpHelper,
    public route: ActivatedRoute,
    public router: Router
  ) { }


  @HostListener('mouseover', ['$event']) onMouseOver(evt: MouseEvent) {
    const target = evt.target as Element
    const container = target.closest('.logos-logo')
    if (!container) {
      this.hoverRow = null
      this.hoverColumn = null
      this.updateLogoPositionsFromHover()
      return 
    }
    const row = +container.getAttribute('data-row')
    const column = +container.getAttribute('data-column')
    if (row == this.hoverRow && column == this.hoverColumn) return
    // console.log('TODO: onMouseOver', row, column)
    this.hoverRow = row
    this.hoverColumn = column
    this.updateLogoPositionsFromHover()
  }

  getHoverLogoMargin(params) {
    const hovered = params['hovered']
    // const row = params['row']
    // const col = params['column']
    // const totalColumns
    switch (this.totalColumns) {
      case 5:
      case 4: {
        if (hovered) {
          if (this.hoverColumn == 1) {
            return '40px 0 40px 10%';
          } else if (this.hoverColumn == this.totalColumns) {
            return '40px 5% 40px 2%';
          } else {
            return '40px 3.5%';
          }
        } else {
          if (this.hoverColumn == 1) {
            return '40px -1.5%';
          } else {
            return '40px -1%';
          }
        }
      }
      case 3: {
        if (hovered) {
          if (this.hoverColumn == 1) {
            return '40px 7% 40px 13%';
          } else {
            return '40px 10%';
          }
        } else {
          if (this.hoverColumn == 1) {
            return '40px -5%';
          } else {
            return '40px -5%';
          }
        }
      }
      case 2: {
        if (hovered) {
          if (this.hoverColumn == 1) {
            return '40px 15% 40px 20%';
          } else {
            return '40px 18%';
          }
        } else {
          if (this.hoverColumn == 1) {
            return '40px -12%';
          } else {
            return '40px -11%';
          }
        }
      }
    }
  }

  updateLogoPositionsFromHover() {
    if (!this.hoverRow || !this.hoverColumn) return this.resetLogoPosititons()
    const hoveredRowLogos = document.querySelectorAll(`.logos-logo[data-row='${this.hoverRow}']`)
    hoveredRowLogos.forEach((logo:HTMLElement) => {
      const isHovered = +logo.getAttribute('data-column') == this.hoverColumn
      logo.style.margin = this.getHoverLogoMargin({ hovered: isHovered })
      // if (+logo.getAttribute('data-column') == this.hoverColumn) {
      //   logo.style.margin = this.getHoverLogoMargin({ hovered: true })
      // } else {
      //   logo.style.margin = this.getHoverLogoMargin({ hovered: false })
      // }
    })

    const otherRowLogos = document.querySelectorAll(`.logos-logo:not([data-row='${this.hoverRow}'])`)
    this.resetLogos(otherRowLogos)
    // console.log('hoveredRowLogos', hoveredRowLogos)
  }

  resetLogoPosititons() {
    this.resetLogos(document.querySelectorAll('.logos-logo'))
  }

  resetLogos(logos) {
    logos.forEach((logo:HTMLElement) => {
      logo.style.margin = '40px 0';
    })
  }


  // @HostListener('mouseleave') onMouseLeave() {
  //   this.renderer.setStyle(this.el.nativeElement, 'background-color', null); // Remove background color
  // }

  ngOnInit(): void {
    this.getTags()
    this.getPage()
    this.queryParamStream()
    this.windowResizeStream()

    this.updateLogoRowCol()
  }

  ngOnDestroy() {
    this.destroy$.next(true)
    this.destroy$.unsubscribe()
  }

  getPage(){
    this.contentService.getPage({'fields.slug': this.slug })
    .pipe(takeUntil(this.destroy$))
    .subscribe({
      next: (content) => {
        this.content = content
        if (!this.content) return console.log('!content', this.content)
        let firstItem = this.content.items[0]
        // console.log('content, first item', this.content, firstItem)
        this.fields = this.content.items[0].fields     
        // console.log('logos-fields', this.fields)     
        this.placeholder = this.fields['placeholder'] || LcpHelper.defaultListPlaceholderHTML

        this.updateFiltersFromFields(this.fields)
        // console.log('fg', this.filterGroups);
      }
    })
  }

  getTags() {
    this.contentService.getTags()
    .pipe(takeUntil(this.destroy$))
    .subscribe({
      next: (tags) => {
        // console.log('TODO: tags', tags)
        this.tags = tags
      }
    })
  }

  updateLogoRowCol() {
    const sequence = Array.from({ length: this.maxLogos }, (value, index) => index);
    const columns = this.totalColumns // 5
    let logoRow = []
    let logoColumn = []
    sequence.forEach(i => {
      logoRow[i] = Math.ceil((i+1)/columns)
      logoColumn[i] = i % columns + 1
    })
    this.logoRow = logoRow
    this.logoColumn = logoColumn
    // console.log('this.logoRow', this.logoRow)
  }

  queryParamStream() {
    this.route.queryParams
    .pipe(takeUntil(this.destroy$))
    .subscribe(qp => {
      this.queryParams = qp
      // console.log('qp', qp)
      this.updateActiveFiltersFromQueryParams()
      this.fadeOutLogos().then(res => {
        this.updateLogos()
      })
    })
  }

  windowResizeStream() {
    if (!AppStatic.isBrowser) return
    const width = fromEvent(window, "resize").pipe(map(() => window.innerWidth));
    const height = fromEvent(window, "resize").pipe(map(() => window.innerHeight));
    const combined = combineLatest([width, height]);
  
    const dimensions = combined.pipe(
      // throttleTime(100),
      map(([width, height]) => ({ width, height }))
    )
  
    return dimensions
    .pipe(takeUntil(this.destroy$))
    .subscribe(res => {
      // console.log('WINDOW DIM', res)
      this.updateFromWindowWidth()
    }) 
  }


  updateFiltersFromFields(fields: any) {
    // RM: information & environmental design
    // RM: strategic outreach
    
    this.filterGroups = this.fields['filterGroups']
    this.anyFilterGroup = this.filterGroups[0]
    this.clientFilterGroup = this.filterGroups[1]
    this.clientFilters = this.clientFilterGroup.fields['items']

    // this.activeFilterGroup = this.filterGroups[0]

    this.filterGroups.map((group:any) => {
      if (!group.fields.items) return
      for (let filter of group.fields.items) {
        filter.metadata['filterGroupName'] = group.fields['name']
        return filter
        // console.log('filter', group, filter)
      }
    })
    this.updateActiveFiltersFromQueryParams()
  }

  updateLogos() {
    this.contentService.getClients(this.clientsQueryFromQueryParams())
    .subscribe({
        next: (clients) => {
          // this.clients = this.sortSequence(clients.items, 'title')
          if (!clients) {
            console.log('!clients', clients)
            // return setTimeout(this.updateLogosNow.bind(this, 1000), 1000)
          }
          // console.log('UPN')
          return this.updateLogosNow(clients)
          // console.log('updateLogos', this.clients, clients);
          return clients
        }
    });
  }

  updateLogosNow(clients, delay?) {
    if (!clients || !clients.items || !this.clientFilters ) return console.log('ERR: !clients || !clientFilters', clients)
      
    // console.log('CLIENTS', clients)
    // clients = this.sortSequence(clients.items, 'name')
    // clients = this.sortSequence(clients.items, "logo.fields['title']")
    clients = clients.items.sort((a, b) => {
      const logoNameA = a.fields['logo']?.fields['title']
      const logoNameB = b.fields['logo']?.fields['title']
      return logoNameA.localeCompare(logoNameB)
    })

    // console.log('CHECK clients', clients)

    clients.map(client => {
      // hide unless src (cover image) set

      if (!client.metadata) console.log('NO METADATA...')
      client.metadata ||= {}
      if (client.fields['logo']) client.metadata['src'] = this.urlFromMedia(client.fields['logo'])
      // logo.metadata['innerHtml'] = this.lcpHelper.htmlFromRichText(logo.fields['tagline'])
      return client
    })

    // remove if no cover src
    // if (!logo.metadata['src']) return
    this.logos = clients.filter(p => !!p.metadata['src'])

    // console.log('CHECK logo', this.logos[0])

    this.logos.forEach(logo => {
      if (logo.fields['primaryColor']) {
        const primaryColor = this.lcpHelper.normalizedHex(logo.fields['primaryColor'])
        logo.metadata['primary-color'] = primaryColor
        logo.metadata['is-inverted'] = this.lcpHelper.colorIsDarkAdvanced(primaryColor)// this.lcpHelper.shouldUseWhiteOverColor(primaryColor)
      } 
      // else {
      //   console.log('no primary color?', logo)
      // }

      const industryTagIds = logo.metadata.tags.map(tag => tag?.sys?.id)
      if (!this.clientFilters) return console.log('ERR: !clientFilters')
      const filter = this.clientFilters.find(filter => filter.fields['name'] == industryTagIds[0])
      // console.log('CHECK filter', filter, industryTagIds[0], this.clientFilters[0])
      if (!filter) return
      logo.metadata['industry'] = filter.fields['display']
      // console
      // const primaryColor = this.lcpHelper.primaryColorHex(logo.fields['primary-color'])
      // logo.metadata['is-inverted'] = this.lcpHelper.shouldUseWhiteOverColor(primaryColor)
    })

    setTimeout(this.fadeInLogos.bind(this), 100);

    // if (this.logosSizing) 
    setTimeout(this.updateFromWindowWidth.bind(this), 100)

    // console.log('logosSizing', this.logosSizing.nativeElement, this.logosSizing.nativeElement.offsetHeight)

    this.detectChanges()
    return this.logos
  }

  updateFromWindowWidth() {
    if (!AppStatic.isBrowser) return
    // if (!this.logosSizing) return
    // console.log('updateFromWindowWidth', window.innerWidth)
    const width = window.innerWidth
    // this.isFourColumns = this.breakpointThreeColumns < width && width <= this.breakpointFourColumns
    // this.isThreeColumns = this.breakpointTwoColumns < width && width <= this.breakpointThreeColumns
    // this.isTwoColumns = width <= this.breakpointTwoColumns
    let totalColumns

    if (width > this.breakpointFourColumns) {
      totalColumns = 5
    } else if (width > this.breakpointThreeColumns) {
      totalColumns = 4
    } else if (width > this.breakpointTwoColumns) {
      totalColumns = 3
    } else {
      totalColumns = 2
    }

    if (totalColumns == this.totalColumns) return

    this.updateColumns(totalColumns)    

    // console.log('updateFromWindowWidth', window.innerWidth, this.breakpointFourColumns, this.totalColumns)

    // this.detectChanges()
    // const offsetHeight = this.logosSizing.nativeElement.offsetHeight

    // console.log('TODO: fix & set height? ', offsetHeight)

    // // this.logosContainerOuter.nativeElement.style.height = `${offsetHeight}px`

    // this.detectChanges()
  }

  updateColumns(columns: number) {
    this.totalColumns = columns

    this.updateLogoRowCol()

    this.detectChanges()
  }

  sortSequence(sequence: any[], field: string) {
    return AppStatic.sortSequence(sequence, field) // sequence.sort((a, b) => a.fields[field].localeCompare(b.fields[field]))
  }

  clientsQueryFromQueryParams() {
    // console.log('clientsQueryFromQueryParams', this.queryParams, this.logos, this.queryParams['tag'] )
    if (!this.queryParams['tag']) return {}
    return {
      'metadata.tags.sys.id[in]': Array(this.queryParams['tag']),
      // 'metadata.tags.sys.id[in]': Array(this.queryParams['tag']),
    }
  }

  fadeOutLogos() {
    // console.log('FADE OUT')
    this.showLogos = false
    this.detectChanges()
    return this.lcpHelper.delay(100).then(() => null)
  }

  fadeInLogos() {
    this.showLogos = true
    this.detectChanges()
  }

  filterDataFromParams(params:any = {}) {
    if (params['filter']) {
      let filter = params['filter']
      return { type: filter.fields['type'], 
               name: filter.fields['name'],
               filterGroup: filter.fields['filterGroup'] }
    }
    return { type: params['type'], name: params['name'] }
  }

  updateActiveFiltersFromQueryParams() {
    if (!this.queryParams) return
    this.activeFilters = []
    for (let key of Object.keys(this.queryParams)) {
      // console.log('SET', key, this.queryParams[key], Array(this.queryParams[key]), Array.isArray(this.queryParams[key]))
      if (Array.isArray(this.queryParams[key])) {
        for (let name of this.queryParams[key]) {
          this.activeFilters.push(this.filterDataFromParams({ type: key, name: name }))
        }
      } else {
        this.activeFilters.push(this.filterDataFromParams({ type: key, name: this.queryParams[key]}))
      }
    }

    // console.log('activeFilters', this.activeFilters)
    // this.updateActiveFilterGroupsFromActiveFilters(this.activeFilters)
  }

  filterIsActive(filter: any): boolean {
    return !!this.activeFilters.find(x => x['name'] === filter.fields['name'])
  }

  logoCoverBackgroundImage(logo: any) {
    // logo.fields['media'][0].fields.file.url
    return this.lcpHelper.backgroundImageFromMedia(logo.fields['media'][0])
  }

  // logoPath(logo: any) {
  //   return AppStatic.logoPath(logo) // '/work/' + logo.fields['slug']
  // }

  // handleSelectFilterGroup(filterGroup: any) {
  //   if (!filterGroup || filterGroup.isOpen) return this.resetFilters()

  //   this.filterGroups.map((fg: any) => fg.isOpen = false)

  //   // select 'all' resets filters
  //   if (!filterGroup.fields['items']) return this.resetFilters()

  //   filterGroup.isOpen = true
  //   this.activeFilterGroup = filterGroup
  // }

  handleSelectFilter(filter: any) {
    if (!filter) return this.resetFilters()
    // const tagsFromContentful = this.contentService.getTags()
    // console.log('handleSelectFilter', Object.assign({}, filter))
    filter.isActive = !!filter.isActive ? false : true
    let newFilters = [] 
    let filterData = this.filterDataFromParams({ filter: filter })
    // console.log('FILTER', Object.assign({}, filter))
    if (!this.filterIsActive(filter)) {
      newFilters.push(filterData)
    } else {
      newFilters = [] 
      // newFilters = this.removeFromActiveFiltersGroup(newFilters, filterData) // removed so only one selection possible
    }
    newFilters = newFilters.filter(this.lcpHelper.onlyUnique)
    // console.log('newFilters', Object.assign([], newFilters))
    this.updateRouteFromNewFilters(newFilters)
  }

  resetFilters() {
    this.activeFilterGroup = null
    this.filterGroups.map((fg: any) => fg.isOpen = false)
    return this.updateRouteFromNewFilters(null)
  }

  removeFromActiveFiltersGroup(group: any, filterData: any) {
    return group.filter((el: any) => {
      return !(el['name'] === filterData['name'] && el['type'] === filterData['type'])
    })
  }


  // updateActiveFilterGroupsFromActiveFilters(activeFilters: any[]) {
  //   let groupNames = []

  //   for (let activeFilter of activeFilters) {
  //     // console.log(this.filterGroups.)
  //     this.filterGroups.map(fg => {
  //       fg.fields?.items?.map(filter => {
  //         // console.log('filter', activeFilter.name, filter.fields?.name == activeFilter.name, filter.fields?.name, filter.fields?.filterGroup)
  //         if (filter.fields?.name == activeFilter.name) groupNames.push(filter.fields?.filterGroup)
  //       })
  //     })
  //   }
  //   this.activeFilterGroupNames = groupNames.filter(this.lcpHelper.onlyUnique)
  //   // console.log('activeFilterGroupNames', this.activeFilterGroupNames, activeFilters, groupNames)

  //   for (let filterGroup of this.filterGroups) {
  //     let lc = String(filterGroup.fields['name']).toLowerCase()
  //     // let lcIndex = this.activeFilterGroupNames.indexOf(lc)
  //     // active all active-filter groups
  //     filterGroup['isActive'] = this.activeFilterGroupNames.indexOf(lc) > -1
  //     // open first filter group
  //     if (filterGroup['isActive'] && !this.activeFilterGroup) {
  //       this.activeFilterGroup = filterGroup
  //       filterGroup['isOpen'] = true
  //     }
  //     // console.log('lc', lc, filterGroup, lcIndex, this.activeFilterGroupNames)
  //   }
  //   this.detectChanges()
  // }

  updateRouteFromNewFilters(filters: any) {
    // console.log('urff', filters, this.queryParams)
    let newQueryParams:any = {} // Object.assign({}, this.queryParams)

    let value:any[] = []
    if (filters) filters.map((filter: any) => {
      // console.log('val', value)
      if (!Array.isArray(value)) value = Array(value)
      value.push(filter['name'])
      value = value.filter(this.lcpHelper.onlyUnique)
      // newQueryParams = Object.assign({}, this.queryParams)
      newQueryParams[filter['type']] = value
      // console.log('nqp', newQueryParams, value)
    })

    // console.log('QP', newQueryParams, filters)
    return this.router.navigate([], { 
      queryParams: newQueryParams }) 
      // queryParamsHandling: 'merge' })
  }

  urlFromMedia(media: any) {
    return this.lcpHelper.urlFromMedia(media)
  }

  handleHoverLogo(logo) {
    if (!isDevMode() || !logo.metadata['primary-color']) return

    const l = this.lcpHelper.colorLuminosity(logo.metadata['primary-color'])
    const contrastWithWhite = 1.05 / (l + 0.05)
    const contrastWithBlack = (l + 0.05) / 0.05
    // console.log('color / luminosity / ratio-white / ratio-black')
    // console.log( 
    //   logo.metadata['primary-color'],
    //   l.toFixed(4), 
    //   contrastWithWhite.toFixed(4),
    //   contrastWithBlack.toFixed(4)
    // )
    let tableData = {}
    tableData[logo.metadata['primary-color']] = { 
      luminosity: parseFloat(l.toFixed(4)),
      ratioWhite: parseFloat(contrastWithWhite.toFixed(4)),
      ratioBlack: parseFloat(contrastWithBlack.toFixed(4))
    }
    // console.log('isDevMode', isDevMode())
    // console.table(tableData)
  }

  detectChanges() {
    if (!this.cdr['destroyed']) this.cdr.detectChanges()
  }
}
